export const ZOBJECT_CREATED = 1;
export const ZMESSAGE_CREATED = 2;
export const INLET_CREATED = 3;
export const OUTLET_CREATED = 4;
export const INLET_DELETED = 5;
export const OUTLET_DELETED = 6;
export const CONNECTION_CREATED = 7;
export const CONNECTION_DELETED = 8;
export const ZOBJECT_UPDATED = 9;
export const ZMESSAGE_UPDATED = 10;
export const INLET_TOGGLED = 11;
export const ZOBJECT_DELETED= 12;
export const ZMESSAGE_DELETED= 13;

export const zobjectCreated = (zobject) => ({
    type: ZOBJECT_CREATED,
    zobject
});

export const zmessageCreated = (zmessage) => ({
    type: ZMESSAGE_CREATED,
    zmessage
});

export const inletCreated = (inlet, isInstanceInlet) => ({
    type: INLET_CREATED,
    inlet,
    isInstanceInlet
});

export const outletCreated = (outlet) => ({
    type: OUTLET_CREATED,
    outlet,
});

export const inletDeleted = (inletNumber) => ({
    type: INLET_DELETED,
    inletNumber
});

export const outletDeleted = (outletNumber) => ({
    type: OUTLET_DELETED,
    outletNumber
});

export const connectionCreated = (sourceNode, destNode, sourceType, destType) => ({
    type: CONNECTION_CREATED,
    sourceType,
    destType,
    destNode,
    sourceNode
});

export const connectionDeleted = (sourceNode, destNode, sourceType, destType) => ({
    type: CONNECTION_DELETED,
    sourceType,
    destType,
    destNode,
    sourceNode
});

export const zobjectUpdated = (zobject, text) => ({
    type: ZOBJECT_UPDATED,
    zobject,
    text
});

export const zmessageUpdated = (zmessage, text) => ({
    type: ZMESSAGE_UPDATED,
    zmessage,
    text,
});

export const inletToggled = (inletNumber) => ({
    type: INLET_TOGGLED,
    inletNumber,
});

export const zobjectDeleted= (zobject) => ({
    type: ZOBJECT_DELETED,
    zobject
});

export const zmessageDeleted = (zmessage) => ({
    type: ZMESSAGE_DELETED,
    zmessage
});

